import(/* webpackMode: "eager", webpackExports: ["default"] */ "/build/j2pvzw3d45kl764w5qqadjl4628i8999-source/components/Home.tsx");
;
import(/* webpackMode: "eager" */ "/build/j2pvzw3d45kl764w5qqadjl4628i8999-source/node_modules/next/dist/client/app-dir/link.js");
